var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 0H2.375C1.06504 0 0 1.06504 0 2.375V13.0625C0 14.3725 1.06504 15.4375 2.375 15.4375H5.9375V18.5547C5.9375 18.8182 6.15273 19 6.38281 19C6.47188 19 6.56465 18.974 6.64629 18.9109L11.2812 15.4375H16.625C17.935 15.4375 19 14.3725 19 13.0625V2.375C19 1.06504 17.935 0 16.625 0ZM17.2188 13.0625C17.2188 13.3891 16.9516 13.6562 16.625 13.6562H10.6875L10.2125 14.0125L7.71875 15.8828V13.6562H2.375C2.04844 13.6562 1.78125 13.3891 1.78125 13.0625V2.375C1.78125 2.04844 2.04844 1.78125 2.375 1.78125H16.625C16.9516 1.78125 17.2188 2.04844 17.2188 2.375V13.0625Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/CommentIcon.200e0b0fa3f901543ed33f2e02a43b2d.svg";
export { ForwardRef as ReactComponent };